export default __webpack_public_path__ + "static/media/detail_big_2_4.2af5de7b.png";